import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.to-fixed.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "trWeekly"
  }, [_c('div', {
    staticClass: "pageTitle"
  }, [_vm._v("趨勢週報")]), _c('div', {
    staticClass: "tr_toolbar"
  }, [_c('label', {
    staticClass: "tr_label"
  }, [_vm._v("資料夾")]), _c('b-form-select', {
    staticClass: "tr_root",
    attrs: {
      "options": _vm.roots,
      "size": "sm",
      "disabled": !_vm.roots.length
    },
    model: {
      value: _vm.root,
      callback: function callback($$v) {
        _vm.root = $$v;
      },
      expression: "root"
    }
  }), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light",
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.load
    }
  }, [_c('i', {
    staticClass: "fas fa-sync-alt",
    class: {
      'fa-spin': _vm.loading
    }
  }), _vm._v(" 重新整理 ")]), _vm.d ? _c('span', {
    staticClass: "tr_stamp"
  }, [_vm._v(" 評估週 " + _vm._s(_vm.lastWeek) + "｜資料期間 " + _vm._s(_vm.d.weeks[0]) + "～" + _vm._s(_vm.lastWeek) + "，共 " + _vm._s(_vm.d.weeks.length) + " 週｜引擎 " + _vm._s(_vm.d.engine) + " ")]) : _vm._e()], 1), _vm.error ? _c('b-alert', {
    staticClass: "mx-3",
    attrs: {
      "show": "",
      "variant": "danger"
    }
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e(), _vm.loading && !_vm.d ? _c('b-spinner', {
    staticClass: "mx-3 my-4",
    attrs: {
      "variant": "secondary"
    }
  }) : !_vm.roots.length && !_vm.error ? _c('div', {
    staticClass: "tr_empty"
  }, [_vm._v("尚無趨勢分析結果。")]) : _vm._e(), _vm.d ? [_c('div', {
    staticClass: "tr_note"
  }, [_c('p', [_vm._v("本頁呈現趨勢分析模組之每週評估結果，每週五 04:00 依截至前一日（週四）之資料自動更新。各項目對每一設備每週給予一個燈號；預警單以「項目＋設備」為單位，同一時間僅維持一張。連續 2 週非綠燈即開立預警單，連續 3 週綠燈自動結案。")]), _vm._l(_vm.siteNotes, function (n) {
    return _c('p', {
      key: n
    }, [_vm._v(_vm._s(n))]);
  })], 2), _c('div', {
    staticClass: "tr_tiles"
  }, _vm._l(_vm.tiles, function (t) {
    return _c('div', {
      key: t.k,
      staticClass: "tr_tile"
    }, [_c('div', {
      staticClass: "tr_tileK"
    }, [t.s ? _c('span', {
      staticClass: "tr_dot",
      class: 's-' + t.s
    }) : _vm._e(), _vm._v(_vm._s(t.k))]), _c('div', {
      staticClass: "tr_tileV"
    }, [_vm._v(_vm._s(t.v))])]);
  }), 0), _c('section', {
    staticClass: "tr_panel"
  }, [_c('div', {
    staticClass: "tr_panelHead"
  }, [_c('span', {
    staticClass: "tr_panelTitle"
  }, [_vm._v("每週燈號表")]), _c('b-form-radio-group', {
    attrs: {
      "options": _vm.SPANS,
      "buttons": "",
      "button-variant": "outline-secondary",
      "size": "sm"
    },
    model: {
      value: _vm.gridSpan,
      callback: function callback($$v) {
        _vm.gridSpan = $$v;
      },
      expression: "gridSpan"
    }
  })], 1), _c('p', {
    staticClass: "tr_hint"
  }, [_vm._v("每格為該項目當週所有設備中最嚴重之燈號，格內數字為紅燈及黃燈設備數；游標停留可檢視日期與各燈號設備數。")]), _c('div', {
    staticClass: "tr_legend"
  }, _vm._l(_vm.LEGEND, function (text, s) {
    return _c('span', {
      key: s
    }, [_c('span', {
      staticClass: "tr_dot",
      class: 's-' + s
    }), _vm._v(_vm._s(text))]);
  }), 0), _c('div', {
    staticClass: "tr_scroll"
  }, [_c('table', {
    staticClass: "tr_grid"
  }, [_vm._l(_vm.gridGroups, function (g) {
    return _c('tbody', {
      key: g.name
    }, [_c('tr', {
      staticClass: "tr_grp"
    }, [_c('th', {
      attrs: {
        "colspan": _vm.gridWeeks.length + 1
      }
    }, [_vm._v(_vm._s(g.name))])]), _vm._l(g.items, function (it) {
      return _c('tr', {
        key: it
      }, [_c('th', {
        staticClass: "tr_item"
      }, [_vm._v(_vm._s(it)), _c('small', [_vm._v(_vm._s(_vm.NAMES[it] || ''))])]), _vm._l(_vm.gridWeeks, function (w) {
        return _c('td', {
          key: w.i
        }, [_c('div', {
          staticClass: "tr_cell",
          class: 's-' + _vm.cellLight(it, w.i),
          attrs: {
            "title": _vm.cellTitle(it, w)
          }
        }, [_vm._v(_vm._s(_vm.cellCount(it, w.i)))])]);
      })], 2);
    })], 2);
  }), _c('tbody', [_c('tr', {
    staticClass: "tr_axis"
  }, [_c('td'), _vm._l(_vm.gridWeeks, function (w, k) {
    return _c('td', {
      key: w.i
    }, [k % 6 === 0 ? _c('span', [_vm._v(_vm._s(_vm.md(w.date)))]) : _vm._e()]);
  })], 2)])], 2)])]), _c('section', {
    staticClass: "tr_panel"
  }, [_c('div', {
    staticClass: "tr_panelHead"
  }, [_c('span', {
    staticClass: "tr_panelTitle"
  }, [_vm._v("本週清單")]), _c('b-form-radio-group', {
    attrs: {
      "options": _vm.lightOptions,
      "buttons": "",
      "button-variant": "outline-secondary",
      "size": "sm"
    },
    model: {
      value: _vm.light,
      callback: function callback($$v) {
        _vm.light = $$v;
      },
      expression: "light"
    }
  })], 1), _c('p', {
    staticClass: "tr_hint"
  }, [_vm._v("列出本週各設備之燈號，依嚴重度排序，預設僅列紅燈與黃燈，可切換檢視全部。點選紅燈或黃燈列，可於下方檢視該設備之趨勢圖。右欄為近 12 週燈號（左舊右新）。")]), _c('b-table', {
    staticClass: "tr_table",
    attrs: {
      "items": _vm.listRows,
      "fields": _vm.listFields,
      "small": "",
      "hover": "",
      "tbody-tr-class": _vm.rowClass
    },
    on: {
      "row-clicked": _vm.selectRow
    },
    scopedSlots: _vm._u([{
      key: "cell(status)",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c('span', {
          staticClass: "tr_pill",
          class: 's-' + item.status
        }, [_vm._v(_vm._s(item.status))])];
      }
    }, {
      key: "cell(item)",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_vm._v(" " + _vm._s(item.item)), _c('div', {
          staticClass: "tr_muted"
        }, [_vm._v(_vm._s(_vm.NAMES[item.item] || ''))])];
      }
    }, {
      key: "cell(device)",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [_c('span', {
          staticClass: "tr_num"
        }, [_vm._v(_vm._s(item.device))]), item.noTicket ? _c('b-badge', {
          staticClass: "ml-1",
          attrs: {
            "variant": "light"
          }
        }, [_vm._v("僅顯示")]) : _vm._e(), item.merged ? _c('b-badge', {
          staticClass: "ml-1",
          attrs: {
            "variant": "light"
          }
        }, [_vm._v("併入全場單")]) : _vm._e()];
      }
    }, {
      key: "cell(message)",
      fn: function fn(_ref4) {
        var item = _ref4.item;
        return [_c('div', [_vm._v(_vm._s(item.message || (item.status === '綠' ? '本週恢復正常；預警單於連續 3 週綠燈後結案。' : '—')))]), item.action ? _c('div', {
          staticClass: "tr_muted"
        }, [_vm._v("建議處置：" + _vm._s(item.action))]) : _vm._e()];
      }
    }, {
      key: "cell(opened)",
      fn: function fn(_ref5) {
        var item = _ref5.item;
        return [_c('span', {
          staticClass: "tr_num"
        }, [_vm._v(_vm._s(item.opened ? _vm.md(item.opened) : '—'))])];
      }
    }, {
      key: "cell(weeks)",
      fn: function fn(_ref6) {
        var item = _ref6.item;
        return [_c('div', {
          staticClass: "tr_spark"
        }, _vm._l(item.weeks, function (s, k) {
          return _c('i', {
            key: k,
            class: 's-' + (s || '灰')
          });
        }), 0)];
      }
    }], null, false, 3687332489)
  })], 1), _c('section', {
    ref: "chartPanel",
    staticClass: "tr_panel"
  }, [_c('div', {
    staticClass: "tr_panelHead"
  }, [_c('span', {
    staticClass: "tr_panelTitle"
  }, [_vm._v("趨勢圖")]), _vm.sel ? _c('span', {
    staticClass: "tr_hint"
  }, [_vm._v(_vm._s(_vm.sel.item) + " " + _vm._s(_vm.NAMES[_vm.sel.item] || '') + "｜" + _vm._s(_vm.sel.device))]) : _vm._e()]), _vm.sel && _vm.selSeries ? [_c('p', {
    staticClass: "tr_hint"
  }, [_vm._v(" 藍線為每週趨勢值；紅色虛線為對應既有告警之門檻；底色標示紅燈與黃燈週次；橘色虛線為依近 12 週線性迴歸之外推，僅供參考。 首次亮燈 " + _vm._s(_vm.selSeries.first || '—') + "，開單日 " + _vm._s(_vm.sel.opened || '—') + "。 ")]), _vm.forecast ? _c('div', {
    staticClass: "tr_forecast",
    class: {
      ok: _vm.forecast.ok
    }
  }, [_vm._v(_vm._s(_vm.forecast.text))]) : _vm._e(), _c('highcharts', {
    staticClass: "tr_chart",
    attrs: {
      "options": _vm.trendChart
    }
  })] : _c('p', {
    staticClass: "tr_hint"
  }, [_vm._v("本週無紅燈或黃燈設備。")])], 2), _c('section', {
    staticClass: "tr_panel"
  }, [_vm._m(0), _c('p', {
    staticClass: "tr_hint"
  }, [_vm._v("全期累計開立之預警單張數，依項目列示。")]), _c('b-table', {
    staticClass: "tr_table tr_ticket",
    attrs: {
      "items": _vm.ticketRows,
      "fields": _vm.ticketFields,
      "small": "",
      "foot-clone": ""
    },
    scopedSlots: _vm._u([{
      key: "foot(name)",
      fn: function fn() {
        return [_vm._v("合計")];
      },
      proxy: true
    }, {
      key: "foot(count)",
      fn: function fn() {
        return [_vm._v(_vm._s(_vm.d.tickets.total) + " 張（" + _vm._s(_vm.d.weeks.length) + " 週，平均每週 " + _vm._s((_vm.d.tickets.total / _vm.d.weeks.length).toFixed(2)) + " 張）")];
      },
      proxy: true
    }], null, false, 3874104355)
  })], 1), _c('section', {
    staticClass: "tr_panel"
  }, [_vm._m(1), _c('p', {
    staticClass: "tr_hint"
  }, [_vm._v("每次有效降雨或清洗後歸零重新累計；黃色虛線為 2% 警示線。日照計讀值偏低期間之估計值僅供參考。")]), _c('highcharts', {
    staticClass: "tr_chart",
    attrs: {
      "options": _vm.t4Chart
    }
  })], 1)] : _vm._e()], 2);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "tr_panelHead"
  }, [_c('span', {
    staticClass: "tr_panelTitle"
  }, [_vm._v("開單統計")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "tr_panelHead"
  }, [_c('span', {
    staticClass: "tr_panelTitle"
  }, [_vm._v("T4 髒污損失估計")])]);
}];
export { render, staticRenderFns };